export default __webpack_public_path__ + "static/media/header-logo.fa5b5ada.png";